import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';

import { AuthService, ResolverLoadingService } from 'pbc.angular';

import { IOrtKategoriesResponse } from 'fa-kt.types';
import { PostOrtKategorieCommandService } from '../commands';
import { OrtKategoriesService } from '../query';

@Injectable({
  providedIn: 'root',
})
export class OrtKategoriesPageResolver implements Resolve<IOrtKategoriesResponse | void> {
  constructor(
    private loading: ResolverLoadingService,
    private authService: AuthService,
    private ortKategories: OrtKategoriesService,
    private postOrtKategorie: PostOrtKategorieCommandService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<IOrtKategoriesResponse | void> {
    this.loading.resolving();
    const log = (error: any) => console.error(error);
    const [ortKategories] = await Promise.all([this.ortKategories.request({}).catch(log), this.postOrtKategorie.prepare(true).catch(log)]);
    this.loading.resolved();
    return ortKategories;
  }
}
